const PATH = 'smartcargas/confirmation-term';

export default PATH;
